export default __webpack_public_path__ + "a71f5524537a62e347adbe4313edcb76.png";